import React, { FC } from 'react'
import {
  Breadcrumb as ChakraBreadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Box,
  Stack,
  Text
} from '@chakra-ui/react'

import { ChevronRightIcon } from '@chakra-ui/icons'

import { Breadcrumb } from 'src/components/common/StructuredData'

interface Props {
  items: Array<BreadcrumbsGlobal.Item>
}

const Breadcrumbs: FC<Props> = ({ items }) => {
  return (
    <>
      <Breadcrumb breadcrumbData={items} />

      {items && items.length ? (
        <Box as={Stack} p="l" alignContent="left">
          <ChakraBreadcrumb
            fontFamily="Montserrat-Medium"
            fontSize=".875rem"
            color="baseDark"
            letterSpacing=".2px"
            lineHeight="18px"
            textAlign="left"
            separator={<ChevronRightIcon color="baseDark" />}
          >
            {items.map((item, index) => (
              <BreadcrumbItem key={item.page}>
                {item.href ?
                  <BreadcrumbLink
                    isCurrentPage={index === items.length - 1}
                    href={item.href}
                    title={item.title}
                    color={index !== items.length - 1 ? 'baseDark' : 'baseNeutral.700'}
                    _hover={{
                      textDecoration: 'none',
                      color: 'baseNeutral.700',
                    }}
                  >
                    {item.page}
                  </BreadcrumbLink>
                  : <Text>
                    {item.title}
                  </Text>
                }
              </BreadcrumbItem>
            ))}
          </ChakraBreadcrumb>
        </Box>
      ) : null}
    </>
  )
}

export default Breadcrumbs
